import { post } from "../http";
// 获取版本信息
export const getVersion = params => post(`/app/appVersion/lastVersion`, params);
// 获取体验课列表
export const getClass = params =>
  post(`/web/wechat/experienceClass/list`, params);
// 绑定手机号并兑换课程
export const getExchangeCourse = params =>
  post(`/web/wechat/bindMobileAndExchangeCourse`, params);
